interface MapLegendProps {
  domain: [number, number];
  referenceUsageKwh: number;
}

export function MapLegend({ domain, referenceUsageKwh }: MapLegendProps) {
  return (
    <div className="map-legend" aria-label={`Map legend from ${domain[0]} to ${domain[1]} cents per kilowatt-hour`}>
      <div className="legend-copy">
        <strong>Effective rate</strong>
        <span>Representative plan at {referenceUsageKwh} kWh/month</span>
      </div>
      <div className="legend-scale" aria-hidden="true" />
      <div className="legend-values"><span>{domain[0]} c/kWh</span><span>{domain[1]} c/kWh</span></div>
      <p>Fixed domain across mapped tariff periods. Grey areas have no verified current-period data.</p>
      <small>Boundary source: Municipal Demarcation Board</small>
    </div>
  );
}
